

const targetRouter = {
  path: "/",
  component: () => import("@/components/report/home.vue"),
  children: [{
      path: "/operation_yearly_target",
      name: "operation_yearly_target",
      component: () => import("@/components/query/store/target/operations/year.vue")
    },
    {
      path: "/operation_quarterly_target",
      name: "operation_quarterly_target",
      component: () => import("@/components/query/store/target/operations/quarter.vue")
    },
    {
      path: "/operation_monthly_target",
      name: "operation_monthly_target",
      component: () => import("@/components/query/store/target/operations/month.vue")
    },{
      path: "/operation_target",
      name: "operation_target",
      component: () => import("@/components/query/store/target/operations/full.vue")
    },{
      path: "/marketing_yearly_target",
      name: "marketing_yearly_target",
      component: () => import("@/components/query/store/target/market/year.vue")
    },
    {
      path: "/marketing_quarterly_target",
      name: "marketing_quarterly_target",
      component: () => import("@/components/query/store/target/market/quarter.vue")
    },{
      path: "/monthly_target_manage",
      name: "monthly_target_manage",
      component: () => import("@/components/query/store/target/target/month.vue")
    },{
      path: "/yearly_target_manage",
      name: "yearly_target_manage",
      component: () => import("@/components/query/store/target/target/year.vue")
    },
    {
      path: "/quarterly_target_manage",
      name: "quarterly_target_manage",
      component: () => import("@/components/query/store/target/target/quarter.vue")
    },]
  }

export default targetRouter;